const resources = {
    seeDetails: 'See Details'
};

module.exports = function getResource(label) {
    return resources[label];
};
